import React from "react";

const SafetyNotice = (props) => {
  return (
    <div className="safety-notice">
      Contact your local Service Desk for Patient Critical issues!
    </div>
  );
};

export default SafetyNotice;
